import { type FC, memo } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useToggle } from 'react-use'

import { Typography } from 'antd'
import { PathUtils } from 'routes/routes.utils'

import { ModalAction } from 'common/components/Modal'
import { BUTTON_CONSTANTS } from 'common/constants/buttonConstants'
import { MODAL_LABELS } from 'common/constants/modalConstants'

import ExclamationCircleIcon from 'assets/icons/exclamation-circle.svg?react'
import { CART_CONSTANTS } from 'features/Cart'
import { useCartManager } from 'features/Cart/hooks/useCartManager'

import { BookingThumbnails } from 'features/Home/Dashboard/UserDashboard/ActiveBookings/BookingThumbnails/BookingThumbnails'

import styles from './activeBookings.module.scss'
import type { ActiveBookingsProps } from './activeBookings.types'
const { Title } = Typography

export const ActiveBookings: FC<ActiveBookingsProps> = memo(({ isLoading, bookings }) => {
  const navigate = useNavigate()
  const { siteId } = useParams()

  const [isOpenActionModal, toggleIsOpenActionModal] = useToggle(false)

  const { deleteCart } = useCartManager()

  const handleRemoveCart = async (): Promise<void> => {
    await deleteCart()
    toggleIsOpenActionModal()
    navigate(PathUtils.getBook(siteId))
  }

  return (
    <>
      <Title level={2} className='mt-32 mb-24 font-semibold'>
        Active Bookings
      </Title>

      {bookings?.length === 0 && (
        <div className={styles.noBookings}>
          <ExclamationCircleIcon /> None
        </div>
      )}

      <BookingThumbnails bookings={bookings} isLoading={isLoading} />

      {isOpenActionModal && (
        <ModalAction
          isOpen={isOpenActionModal}
          onConfirm={handleRemoveCart}
          onClose={toggleIsOpenActionModal}
          cancelText={BUTTON_CONSTANTS.CANCEL}
          title={MODAL_LABELS.CONFIRM_CLEAR_CART}
          confirmText={BUTTON_CONSTANTS.CONTINUE}
          description={CART_CONSTANTS.CONFIRM_CLEAR_MESSAGE}
        />
      )}
    </>
  )
})
